import { CloseOutlined } from '@ant-design/icons';
import { Alert, Button } from 'antd';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useSyncStatusQuery } from '@/hooks/queries/useSyncStatusQuery';
import { useCurrentUser } from '@/hooks/useCurrentUser';

import type React from 'react';

interface AtsReauthBannerProps {
  onReconnectComplete?: () => void;
}

const AtsReauthBanner: React.FC<AtsReauthBannerProps> = () => {
  const { t } = useTranslation();
  const { user, isClient } = useCurrentUser();
  const [isDismissed, setIsDismissed] = useState(false);

  const isClientAdmin = isClient && user?.permissions?.view_settings === true;

  const { data: syncStatus, isPending: isLoading } = useSyncStatusQuery({
    enabled: isClientAdmin,
  });

  const needsReauth = syncStatus?.needs_reauth === true;

  const handleDismiss = useCallback(() => {
    setIsDismissed(true);
  }, []);

  if (!isClientAdmin || isLoading || !needsReauth || isDismissed) {
    return null;
  }

  return (
    <Alert
      showIcon={false}
      type="warning"
      title={t('ATS_REAUTH_REQUIRED_MESSAGE')}
      action={
        <Button
          variant="text"
          icon={<CloseOutlined />}
          onClick={handleDismiss}
          aria-label={t('DISMISS')}
        />
      }
    />
  );
};

export default AtsReauthBanner;
